/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Daybreak_LabelInputs */

const bn_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দিনভর`)
};

const de_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagesanbruch`)
};

const el_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ξημέρωμα`)
};

const en_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daybreak`)
};

const es_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recreo de día`)
};

const fr_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aube`)
};

const hi_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भोर`)
};

const hu_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirkadat`)
};

const id_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fajar`)
};

const it_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'alba`)
};

const ja_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`夜明け`)
};

const ko_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새벽`)
};

const nl_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het aanbreken van de dag`)
};

const pl_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brzask`)
};

const pt_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aurora`)
};

const ru_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рассвет`)
};

const sv_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gryning`)
};

const tr_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şafak`)
};

const uk_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Світанок`)
};

const vi_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bình minh`)
};

const zh_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拂晓`)
};

const zh_hant_theme_daybreak_label = /** @type {(inputs: Theme_Daybreak_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拂曉`)
};

/**
* | output |
* | --- |
* | "Daybreak" |
*
* @param {Theme_Daybreak_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const theme_daybreak_label = /** @type {((inputs?: Theme_Daybreak_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Daybreak_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_theme_daybreak_label(inputs)
	if (locale === "de") return de_theme_daybreak_label(inputs)
	if (locale === "el") return el_theme_daybreak_label(inputs)
	if (locale === "en") return en_theme_daybreak_label(inputs)
	if (locale === "es") return es_theme_daybreak_label(inputs)
	if (locale === "fr") return fr_theme_daybreak_label(inputs)
	if (locale === "hi") return hi_theme_daybreak_label(inputs)
	if (locale === "hu") return hu_theme_daybreak_label(inputs)
	if (locale === "id") return id_theme_daybreak_label(inputs)
	if (locale === "it") return it_theme_daybreak_label(inputs)
	if (locale === "ja") return ja_theme_daybreak_label(inputs)
	if (locale === "ko") return ko_theme_daybreak_label(inputs)
	if (locale === "nl") return nl_theme_daybreak_label(inputs)
	if (locale === "pl") return pl_theme_daybreak_label(inputs)
	if (locale === "pt") return pt_theme_daybreak_label(inputs)
	if (locale === "ru") return ru_theme_daybreak_label(inputs)
	if (locale === "sv") return sv_theme_daybreak_label(inputs)
	if (locale === "tr") return tr_theme_daybreak_label(inputs)
	if (locale === "uk") return uk_theme_daybreak_label(inputs)
	if (locale === "vi") return vi_theme_daybreak_label(inputs)
	if (locale === "zh") return zh_theme_daybreak_label(inputs)
	return zh_hant_theme_daybreak_label(inputs)
});